export default __webpack_public_path__ + "static/media/project-gifs.524c345f.jpg";